<template lang="pug">
  //- Alerts List
  transition.alertsTab__Crm(name='slide-AlertDetail' mode="out-in")
    ods-table.alertsTable(
      :data='table' :height='height'
      @row-click='rowClick'
      v-if='Alertlist'
      width="auto"
      )
      ods-table-column(
        width='30')
        template(slot-scope="scope")
          div.sc-dashboard__level
            template(v-if="alert")
              template(v-if="scope.row.severity === 'high'")
                ods-tooltip(content="Alerta importante" placement="top")
                  div.table-dot(class="table-dot--danger")
              template(v-else-if="scope.row.severity === 'medium'")
                ods-tooltip(content="Alerta moderada" placement="top")
                  div.table-dot(class="table-dot--medium")
              template(v-else-if="scope.row.severity === 'low'")
                ods-tooltip(content="Alerta baja" placement="top")
                  div.table-dot(class="table-dot--warning")
              template(v-else)
                ods-tooltip(content="Alerta importante" placement="top")
                  div.table-dot
      ods-table-column(
        :label='$t("fecha")'
        :sortable="true"
        prop='timestamp'
        :formatter="formatDate"
        width='80')
      ods-table-column(
        :prop='$t("subCategory")'
        :label='$t("Tipo")'
        :sortable="true"
        width='80')
      ods-table-column.align-left(
        prop='name'
        :label='$t("Descripción")'
        :sortable="true"
        width="")
      ods-table-column(
        v-if="link"
        prop='id'
        width='50')
        template(slot-scope="scope")
          ods-icon.detail-icon(
            @row-click='rowClick'
            name="arrow-right"
            size="18")
    AlertsDetail(
    :dataDetail='dataStationDetail'
    ref="AlertsDetail"
    alert='true'
    link='true'
    height='100%'
    @closeChild="dataStationDetail = null; Alertlist = true"
    v-else)
</template>

<script>
import IconSvg from '@/components/IconSvg'
import mapElements from '@/mixins/mapElements'
import AlertsDetail from '@/components/AlertDetail'
export default {
  name: 'AlertsListCrm',
  mixins: [ mapElements ],
  props: {
    dataAlert: [],
    dataTable: {
      type: Array
    },
    alert: {
      type: Boolean
    },
    campaign: {
      type: Boolean
    },
    link: {
      type: Boolean
    },
    height: {
      type: String
    },
    fecha: {
      type: String
    }
  },
  data () {
    return {
      table: [],
      dataStationDetail: undefined,
      Alertlist: true,
      date: 'fecha'
    }
  },
  watch: {
    dataTable (newVal, oldVal) {
      const component = this
      component.table = newVal
    }
  },
  methods: {
    formatHour (row, column, cellValue, index) {
      return this.formatLocaleHour(row.date)
    },
    formatDate (row, column, cellValue, index) {
      return this.formatLocaleDate(row.timestamp)
    },
    shortenDescription (row, column, cellValue, index) {
      if (cellValue.length > 80) {
        return cellValue.substring(0, 80) + '...'
      } else {
        return cellValue
      }
    },
    showDetail (data) {
      const component = this
      var obj = {
        list: component.dataTable,
        selected: data
      }
      this.$emit('detailSelect', obj)
    },
    rowClick (row) {
      this.dataStationDetail = []
      this.dataStationDetail = row
      this.dataStationDetail.fecha = this.formatLocaleDate(row.timestamp)
      this.dataStationDetail.hour = this.formatLocaleHour(row.timestamp)
      // this.$refs.AlertsDetail.showAlertDetail()
      this.Alertlist = false
    }
  },
  components: {
    IconSvg,
    AlertsDetail
  },
  created () {
    this.table = this.dataTable
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.ods-tabs__content .ods-tab-pane{
  background: #fff;
}
.slide-AlertDetail-enter-active {
  transition: all .1s ease;
}

.slide-AlertDetail-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-AlertDetail-enter, .slide-AlertDetail-leave-to {
  transform: translateX(50px);
  opacity: 0;
}
/deep/ .ods-table .cell, .ods-table th div {
  padding-right: 0;
}
.sc-dashboard{
  &__level {
    display: flex;
    justify-content: center;
    &__circle {
      align-items: center;
      border-radius: 50%;
      border: 1px solid $--color-primary;
      color: $--color-primary;
      display: flex;
      height: rem(25);
      justify-content: center;
      width: rem(25);
      + .sc-modal__status {
        margin-left: rem(15.5)
      }
      span{
        line-height: 1.1;
      }
    }
  }

  /deep/ .ods-tabs__header{
    margin-bottom: rem(32);
  }
  /deep/ .ods-tabs__nav-scroll{
    padding: 0 rem(32);
  }
  /deep/ .ods-date-editor.ods-input {
    width: rem(125);
  }
}
.alertsTable{
  /* display: none; */
  overflow: scroll;
  /* height: calc(100vh - 165px); */
  > .ods-scrollbar{
    .ods-table__body-wrapper{
      .ods-scrollbar__view{
        height: 20px;
      }
    }
  }
}

.detail-icon{
  cursor: pointer;
}

.ods-table .cell {
  padding: 0 rem(10);
}
</style>



// WEBPACK FOOTER //
// src/components/AlertsAndCampaignListCrm.vue